<template>
    <div role="status" :aria-label="ariaLabel ?? t('components.skeletonLoader.label')" class="animate-pulse bg-border relative z-0" />
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();

type SkeletonLoaderProps = {
    ariaLabel?: string;
};
const { ariaLabel } = defineProps<SkeletonLoaderProps>();
</script>
